import React from 'react'
import { ChevronDown, X } from 'react-feather'

const Label = ({children}) => {
  return (
    <div className="rounded bg-primary text-white px-2 text-xs mr-2 flex items-center cursor-pointer">
      <div className="flex-none">{children}</div>
      <div className="ml-3"><X style={{width: '14px'}}/></div>
    </div>
  )
}

const ListFilter = ({filtered, setFiltered, data}) => {
  return (
    <div>
      <div className="justify-between mb-8 text-sm hidden lg:flex">
        <p className="font-medium" style={{color: '#444'}}>
          1-{data ? data.length : '6'} of {data ? data.length : '6'} results
        </p>
        <div className="flex">
          <p className="mr-1">Sort by:</p>
          <div className="relative pr-4 cursor-pointer">
            <select className="appearance-none cursor-pointer bg-transparent mr-4 w-full">
              <option>Alphabet</option>
            </select>
            <ChevronDown
              className="absolute right-0 top-0"
              style={{width: '16px'}}
            />
          </div>
        </div>
      </div>
      {
        filtered &&
        <div className="flex items-center mb-5 lg:mb-10 pl-5 lg:pl-0" onClick={() => setFiltered(false)}>
          <div className="w-3/4 lg:w-auto filter-items-wrapper order-2 lg:order-1">
            <div className="filter-items flex items-center overflow-x-auto pl-10 lg:pl-0">
              <Label>Prevention</Label>
              <Label>NGO</Label>
              <Label>Intervention</Label>
              <Label>Jawa Timur</Label>
            </div>
          </div>
          <div className="w-1/4 lg:w-auto opacity-50 lg:opacity-100 order-1 lg:order-2 text-gray-444 underline text-xs lg:ml-4 cursor-pointer flex-none">Clear all filters</div>
        </div>
      }
    </div>
  )
}

export { ListFilter }